import { CDN } from '../config';

export default {
  version: 8,
  name: 'seatcrawler',
  metadata: {
    'mapbox:autocomposite': true,
    'mapbox:type': 'template',
    'mapbox:trackposition': false,
    'mapbox:groups': {},
  },
  light: {
    anchor: 'viewport',
  },
  sources: {},
  layers: [],
  glyphs: `${CDN}/fonts/{fontstack}/{range}.pbf`,
};



// WEBPACK FOOTER //
// ./src/styles/empty-style.js